import {FormInput} from "@/Components/Controls";
import i18n from "i18next";
import React from "react";

export default function SetPasswordForm({errors, data, onChange, state}) {

    return (
        <div>
            <div className="row">
                <FormInput
                    error={errors["password"]}
                    format="password"
                    name="password"
                    visibilityIcon={true}
                    value={data.password}
                    onChange={onChange}
                    label={i18n.t("set-password.password")}
                    className="col-12"
                    dataTestid="set_password-input-password"
                />
            </div>
            <div className="row validation-list">
                <p>{i18n.t("set-password.password-contain")}:</p>
                {state.validationItems.map((item, index) =>
                    <div
                        key={index}
                        className={`col-xs-12 list-item ${item.valid ? 'success' : ''}`}
                    >
                        {
                            item.valid !== null ?
                                item.valid ? <i className="fas fa-check-circle"></i> : <i className="fas fa-times-circle"></i>
                                : <i className="fas fa-circle"></i>
                        }
                        {
                            item.valid !== null ?
                                item.valid ?
                                    <span data-testid="set_password_form-span-validation_item_valid"
                                                   className="item-name weight-600">{item.name}</span> :
                                    <span className="item-name"
                                          data-testid="set_password_form-span-validation_item_invalid">{item.name}</span>
                                : <span className="item-name"
                                        data-testid="set_password_form-span-validation_item">{item.name}</span>
                        }
                    </div>
                )}
            </div>
            <div className="row">
                <FormInput
                    error={errors["password_confirmation"]}
                    format="password"
                    name="password_confirmation"
                    visibilityIcon={true}
                    value={data.password_confirmation}
                    onChange={onChange}
                    label={i18n.t("set-password.confirm-password")}
                    className="col-12"
                    dataTestid="set_password-input-confirm_password"
                />
            </div>
        </div>
    )
}
